import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import api from "../lib/api";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useSEO } from "../hooks/useSEO";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useSEO(
    post ? `${post.title} | NAKSRA Sangha` : "Sangha | NAKSRA",
    post ? post.meta_description : "Vedic astrology insights from Sangha, the NAKSRA community."
  );

  useEffect(() => {
    setPost(null);
    setNotFound(false);
    api
      .get(`/blog/${slug}`)
      .then((r) => setPost(r.data))
      .catch(() => setNotFound(true));
  }, [slug]);

  return (
    <div className="min-h-screen bg-[#050507] text-[#F8F9FA]">
      <Navbar />
      <main className="mx-auto max-w-3xl px-6 py-20">
        {notFound ? (
          <div className="text-center" data-testid="post-not-found">
            <h1 className="font-heading text-4xl">Article not found</h1>
            <Link to="/blog" data-testid="post-back-link" className="mt-6 inline-block text-[#D4AF37] hover:text-[#FBE18D]">Back to the Sangha</Link>
          </div>
        ) : !post ? (
          <p className="text-[#A1A1AA]">Loading…</p>
        ) : (
          <article data-testid="blog-article">
            <Link to="/blog" data-testid="article-back-link" className="inline-flex items-center gap-2 text-sm text-[#A1A1AA] transition-colors duration-300 hover:text-[#D4AF37]">
              <ArrowLeft className="h-4 w-4" /> All articles
            </Link>
            <p className="mt-10 text-xs uppercase tracking-[0.2em] text-[#A1A1AA]">
              {new Date(post.created_at).toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" })} · {post.author}
            </p>
            <h1 className="mt-4 font-heading text-4xl font-medium leading-tight tracking-tight sm:text-5xl">{post.title}</h1>
            <p className="mt-6 border-l-2 border-[#D4AF37] pl-5 text-lg italic leading-relaxed text-[#A1A1AA]">{post.excerpt}</p>
            <div className="mt-10 space-y-6">
              {post.content.split(/\n\s*\n/).map((para, i) => (
                <p key={i} className="leading-relaxed text-gray-300">{para}</p>
              ))}
            </div>
            <div className="mt-16 rounded-lg border border-[#D4AF37]/30 bg-[#0C0C10] p-8">
              <h2 className="font-heading text-2xl font-medium">Want this applied to your own chart?</h2>
              <p className="mt-3 text-sm leading-relaxed text-[#A1A1AA]">
                Every NAKSRA report is computed from your exact birth details and verified by a qualified Vedic astrologer — with the full methodology shown.
              </p>
              <Link to="/services" data-testid="article-cta" className="mt-6 inline-block rounded-full bg-[#D4AF37] px-8 py-3 text-sm font-semibold text-black transition-colors duration-300 hover:bg-[#FBE18D] active:scale-[0.98]">
                Explore reports
              </Link>
            </div>
          </article>
        )}
      </main>
      <Footer />
    </div>
  );
}
